import { render, staticRenderFns } from "./judgmentTopic.vue?vue&type=template&id=52643efc&scoped=true"
import script from "./judgmentTopic.vue?vue&type=script&lang=js"
export * from "./judgmentTopic.vue?vue&type=script&lang=js"
import style0 from "./judgmentTopic.vue?vue&type=style&index=0&id=52643efc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52643efc",
  null
  
)

export default component.exports